import { create } from 'zustand';

export const useCookieConsentStore = create((set, get) => ({
    cookieConsent: null,
    showBanner: false,
    cookieConsentExpiration: null,

    setCookieConsent: (consentValue) => {
        const expirationDate = new Date();
        expirationDate.setMonth(expirationDate.getMonth() + 6);
        set(
            {
                cookieConsent: consentValue,
                cookieConsentExpiration: expirationDate,
                showBanner: false
            });

        localStorage.setItem("bgt_cookie_consent_expiration", expirationDate.toISOString());
        localStorage.setItem("bgt_cookie_consent_status", consentValue ? 'accepted' : 'declined');
    },

    setShowBanner: (show) => { 
        set({ showBanner: show })
    },

    getCookieConsent: () => {
        const { cookieConsent, cookieConsentExpiration } = get();
        const now = new Date();

        if (cookieConsent !== null) {
            if (cookieConsentExpiration && cookieConsentExpiration < now) {
                set({ cookieConsent: null, cookieConsentExpiration: null });
            } else {
                return cookieConsent;
            }
        }

        try {
            var storedConsent = localStorage.getItem("bgt_cookie_consent_status");
            var storedExpiration = localStorage.getItem("bgt_cookie_consent_expiration");
        } catch (error) {
            set({ cookieConsent: false, showBanner: true  });
            return false;
        }

        if (storedExpiration) {
            storedExpiration = new Date(storedExpiration);
        }

        if (storedConsent == null || (storedExpiration && storedExpiration < now)) {
            set({ cookieConsent: false, showBanner: true  });
            return false;
        }

        
        const finalConsent = storedConsent === "accepted";
        set({
            cookieConsent: finalConsent,
            cookieConsentExpiration: storedExpiration
        });

        return finalConsent;
    },


}));